var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Calling"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calling"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M14.353 3C18.054 3.411 20.978 6.331 21.393 10.032",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M14.353 6.54297C16.124 6.88697 17.508 8.27197 17.853 10.043",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0315 12.9724C15.0205 16.9604 15.9254 12.3467 18.4653 14.8848C20.9138 17.3328 22.3222 17.8232 19.2188 20.9247C18.8302 21.237 16.3613 24.9943 7.68447 16.3197C-0.993406 7.644 2.76157 5.17244 3.07394 4.78395C6.18377 1.67385 6.66682 3.08938 9.11539 5.53733C11.6541 8.0765 7.04254 8.98441 11.0315 12.9724Z",
    stroke: "#656565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskIcon);
export default __webpack_public_path__ + "static/media/desk-icon.4250e9ef815c277d3662b257180ba7ce.svg";
export { ForwardRef as ReactComponent };